import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { PATH_HOME, PATH_ABOUT_US } from '../global';
import { PATH_PATIENTS } from '../patients/patients.global';
import { PATH_STUDENTS } from '../students/students.global';
import { PATH_MEDICATIONS } from '../medications/medications.global';
import {
  PATH_SETTINGS,
  PATH_SETTINGS_GENERAL,
  PATH_SETTINGS_HELP,
} from '../settings/settings.global';
import {
  selectIsAdmin,
  selectIsLoggedIn,
} from 'src/app/calvin-emr-shared/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { logout } from 'src/app/calvin-emr-shared/state/auth/auth.actions';
import { CalvinEMRSharedModule } from '../calvin-emr-shared/calvin-emr-shared.module';
import { AsyncPipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CustomerInfo } from 'src/environments/deploy_info';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  standalone: true,
  imports: [
    CalvinEMRSharedModule,
    RouterLink,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class NavBarComponent {
  // Local constants
  homePath = PATH_HOME;
  patientsPath = PATH_PATIENTS;
  studentsPath = PATH_STUDENTS;
  medicationsPath = PATH_MEDICATIONS;
  aboutUsPath = PATH_ABOUT_US;
  settingsPath = PATH_SETTINGS;

  // Get customer information from the environment, so that
  // the logo, etc. is correct.
  customer: CustomerInfo;

  /**
   * Menu items to display under the "Profile" split button.
   */
  profileItems: MenuItem[] = [
    {
      label: 'Settings',
      icon: 'pi pi-cog',
      command: () => {
        this.navigateToSettingsGeneral();
      },
    },
    {
      label: 'Help',
      icon: 'pi pi-question-circle',
      command: () => {
        this.navigateToSettingsHelp();
      },
    },
    { separator: true },
    {
      label: 'Log Out',
      icon: 'pi pi-sign-out',
      command: () => {
        this.logout();
      },
    },
  ];

  /**
   * Local reference to the loggedIn Observable in order to determine the current
   * auth state.
   */
  loggedIn: Observable<boolean | null>;
  isAdmin: Observable<boolean>;

  constructor(private router: Router, private store: Store) {
    this.loggedIn = this.store.select(selectIsLoggedIn);
    this.isAdmin = this.store.select(selectIsAdmin);

    this.customer = environment.customer;
  }

  /**
   * Navigates to '/settings/general' path.
   */
  navigateToSettingsGeneral() {
    this.router.navigateByUrl(`${PATH_SETTINGS}/${PATH_SETTINGS_GENERAL}`);
  }

  /**
   * Navigates to '/settings/help' path.
   */
  navigateToSettingsHelp() {
    this.router.navigateByUrl(`${PATH_SETTINGS}/${PATH_SETTINGS_HELP}`);
  }

  /**
   * Calls the Store to log the user out.
   */
  logout() {
    this.store.dispatch(logout());
  }
}
